import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Meta, Title } from '@angular/platform-browser';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
import { UserService } from '../../services/user.service';
import { Subscription, from } from 'rxjs';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-recurso-formulario',
  templateUrl: './recurso-formulario.component.html',
  styleUrls: ['./recurso-formulario.component.scss']
})
export class RecursoFormularioComponent implements OnInit {
  @ViewChild('content') content;
  form: NgForm;
  card: any;
  id: any;

  downloadEnable: boolean = false;

  formView: any = 'register';
  formData: any = {
    email: '',
    name: '',
    age: false,
    policy: false,
    institution: ''
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public user: UserService,
    public api: RestapiService,
    public seo: SeoService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.formView = this.user.isVisitor() === true ? 'logued' : 'register';
    this.api.getdata('webresource', {
      filters: {
        id: { value: this.id },
      },
      per_page: 10
    }).subscribe(res => {
      if (res.status == true) {
        console.log('webresource', res);
        if (res.result.data.length > 0) {
          this.card = res.result.data[0]
          this.seo.generateTags({
            title: 'WWF Educación Ambiental, ' + this.card.tagtitle,
            description: this.card.tagdescription,
            image: this.card.tagimage,
            slug: window.location.href,
          });
        }
      }
    })
  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  register(form: NgForm) {
    console.log('register', form.valid, this.formData, form.value);
    if (form.valid) {
      this.downloadEnable = true;
      this.user.rememberVisitor(this.formData);
      this.formView = 'logued';
      /*
      this.formdata.resource = this.id;
      this.api.store('webvisitor', this.formData, false)
        .subscribe(resData => {
          console.log('signin resData', resData);
        }); */
    }
  }
  login(form: NgForm) {
    console.log('register', form.valid, this.formData, form.value);
    if (form.valid) {
      this.downloadEnable = true;
      this.user.rememberVisitor(this.formData);
      this.formView = 'logued';
    }
    /*  this.user.signin(this.formData)
     .subscribe(resData => {
       console.log('signin resData', resData);
     }); */
  }


  openTerms() {
    //console.log('selected')
    this.modalService.open(this.content,
      { windowClass: "app-modal-terms" });
  }
}
